import { LoadOrdersReportUsecase, LoadOrdersReportUsecaseImp } from 'domain/usecases/load-orders-report-usecase';
import { makeLoadOrdersReportRepository } from '../repositories/cache/orders-history-cache-repository-factory';

export const makeLoadOrdersReportUsecase = (): LoadOrdersReportUsecase => {
  return new LoadOrdersReportUsecaseImp(makeLoadOrdersReportRepository());
};
